module.exports = __webpack_public_path__ + "img/UBIQUITI.52aaf23b.svg";